import { render, staticRenderFns } from "./BizDirectInvoiceImport.vue?vue&type=template&id=ec7e4cd0&scoped=true&"
import script from "./BizDirectInvoiceImport.vue?vue&type=script&lang=js&"
export * from "./BizDirectInvoiceImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7e4cd0",
  null
  
)

export default component.exports